import React, { useState, useEffect } from "react";
import DatePicker from '../Date';
import { fillatd } from '../api/ApiAtd';

export default function FillAttendence({ sesInfo, setsesInfo }) {
    const MONTH_NAMES = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];
    const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    const [showDatepicker, setShowDatepicker] = useState(false);
    const [selectedDate, setSelectedDate] = useState("");
    const [datepickerValue, setDatepickerValue] = useState("");
    const [month, setMonth] = useState(new Date().getMonth());
    const [year, setYear] = useState(new Date().getFullYear());
    const [noOfDays, setNoOfDays] = useState([]);
    const [blankDays, setBlankDays] = useState([]);

    useEffect(() => {
        initDate();
        getNoOfDays();
    }, []);

    useEffect(() => {
        getNoOfDays();
    }, [month, year]);

    const initDate = () => {
        const today = new Date();
        setSelectedDate(today);
        const formattedDate = formatDateForDisplay(today);
        setDatepickerValue(formattedDate);
        setSelectedDate(formattedDate);
    };

    function compareDates(dateDay, dateMonth, dateYear, day, month, year) {
        // First compare the year
        if (dateYear < year) {
            return true; // dateString is lesser (earlier)
        } else if (dateYear > year) {
            return false; // dateString is greater (later)
        }
    
        // If years are equal, compare the month
        if (dateMonth < month) {
            return true; // dateString is lesser (earlier)
        } else if (dateMonth > month) {
            return false; // dateString is greater (later)
        }
    
        // If both year and month are equal, compare the day
        if (dateDay < day) {
            return true; // dateString is lesser (earlier)
        } else {
            return false; // dateString is greater or equal (later or equal)
        }
        
    }
    
    const [sesdateDay, sesdateMonth, sesdateYear] = sesInfo.sesDet.sesStart.split("-").map(Number);
    const formatDateForDisplay = (date) => {
        const formattedDate = ("0" + date.getDate()).slice(-2);
        const formattedMonth = ("0" + (date.getMonth() + 1)).slice(-2);
        const formattedYear = date.getFullYear();
        return `${formattedDate}-${formattedMonth}-${formattedYear}`;
    };

    const getDateValue = (date) => {
        if(compareDates(date, month+1, year,sesdateDay, sesdateMonth, sesdateYear)){
            return;
        }
        const selected = new Date(year, month, date);
        const formattedDate = formatDateForDisplay(selected);
        setDatepickerValue(formattedDate);
        setShowDatepicker(false);
        setSelectedDate(formattedDate);

    };

    const getNoOfDays = () => {
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const dayOfWeek = new Date(year, month).getDay();

        const blankdaysArray = Array.from({ length: dayOfWeek }, (_, i) => i + 1);
        const daysArray = Array.from({ length: daysInMonth }, (_, i) => i + 1);

        setBlankDays(blankdaysArray);
        setNoOfDays(daysArray);
    };

    const handlePrevMonth = () => {
        if(compareDates(1, month+1, year,2, sesdateMonth, sesdateYear)){
            return
        }
        if (month === 0) {
            setMonth(11);
            setYear(year - 1);
        } else {
            setMonth(month - 1);
        }
    };

    const handleNextMonth = () => {
        if (month === 11) {
            setMonth(0);
            setYear(year + 1);
        } else {
            setMonth(month + 1);
        }
    };
    const closeDate = (e) => {
        // Close modal if clicked outside the modal content
        if (e.target.id !== "authentication-date") {
            setShowDatepicker(false);
        }
    }
    const [attendance, setAttendance] = useState({});
    const [loadingStates, setLoadingStates] = useState({});


    const getDayOfWeek = (dateString) => {
        const [day, month, year] = dateString.split("-").map(Number);
        const dateObject = new Date(year, month - 1, day);
        return dateObject.toLocaleString("en-US", { weekday: "long" });
    };
    const currentDay = getDayOfWeek(selectedDate);
    const subjectsForDay = sesInfo.sesData.schedule[currentDay] || [];

    const updateAttendance = (newAttendance, existingData) => {
        const updatedAttendance = { ...existingData.sesData.attendance }; // Clone the existing attendance
        Object.keys(newAttendance).forEach((date) => {
            const newSubjects = newAttendance[date];
            if (!updatedAttendance[date]) {
                updatedAttendance[date] = { ...newSubjects };
            } else {
                // Date exists, process subjects
                Object.keys(newSubjects).forEach((subjectCode) => {
                    const newStatus = newSubjects[subjectCode];
                    if (newStatus === "Present") {
                        delete updatedAttendance[date][subjectCode];
                        if (Object.keys(updatedAttendance[date]).length === 0) {
                            delete updatedAttendance[date];
                        }
                    } else {
                        updatedAttendance[date][subjectCode] = newStatus;
                    }
                });
            }
        });

        // Return the updated structure
        return {
            ...existingData,
            sesData: {
                ...existingData.sesData, // Copy the existing sesData object
                attendance: updatedAttendance, // Update the attendance property
            },
        };
    };



    const handleCheckboxChange = async (subjectId, type) => {
        try {
            if(type === "Cancel"){
                setLoadingStates((prevState) => ({ ...prevState, [subjectId]: {"Cancel":true} }));
            }else if(type === "Absent"){
                setLoadingStates((prevState) => ({ ...prevState, [subjectId]: {"Absent":true} }));
            }
            let updatedValue = "Present";
            if ((sesInfo.sesData.attendance[selectedDate] && sesInfo.sesData.attendance[selectedDate][subjectId] && sesInfo.sesData.attendance[selectedDate][subjectId] === type) || false) {
                updatedValue = "Present";
            } else {
                updatedValue = type;
            }
            setAttendance((prev) => ({
                ...prev,
                [subjectId]: updatedValue,
            }));
            const dataToSend = {
                [selectedDate]: {
                    [subjectId]: updatedValue,
                },
            };
            const response = await fillatd(sesInfo.sesDet._id, dataToSend);
            if (response && response.data && response.data.success) {
                const updatedData = updateAttendance(dataToSend, sesInfo);
                setsesInfo(updatedData)
            }
        } catch (error) {
            console.error("Error saving data:", error);
            alert("An error occurred while saving data.");
        } finally {
            setLoadingStates((prevState) => ({ ...prevState, [subjectId]: false }));
        }
    };
    return (
        <div className="mt-4 p-5 rounded-lg bg-slate-50 w-full">
            <div className="max-w-3xl mx-auto bg-slate-50 rounded-md">
                <h2 className="text-md bg-slate-100 rounded-lg px-2 py-1 mb-3 font-semibold text-gray-800">Attendance for {selectedDate}</h2>
                <div className="relative">
                    <input
                        type="text"
                        onClick={() => setShowDatepicker(!showDatepicker)}
                        value={datepickerValue}
                        readOnly
                        className="border border-gray-300 text-gray-900 sm:text-sm rounded-xl focus:border-gray-300 block w-full p-2.5 cursor-pointer"
                        placeholder="Select date"
                    />
                    {showDatepicker && (
                        <div id="authentication-date" className="bg-white mt-2 rounded-lg shadow p-4 absolute z-10 top-10 left-0" style={{ width: "17rem" }}>
                            <div className="flex justify-between items-center mb-2">
                                <div>
                                    <span className="text-lg font-bold text-gray-800">{MONTH_NAMES[month]}</span>
                                    <span className="ml-1 text-lg text-gray-600 font-normal">{year}</span>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        onClick={handlePrevMonth}
                                        className="focus:outline-none transition ease-in-out duration-100 inline-flex cursor-pointer hover:bg-gray-100 p-1 rounded-full"
                                    >
                                        <svg
                                            className="h-6 w-6 text-gray-400"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M15 19l-7-7 7-7"
                                            />
                                        </svg>
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleNextMonth}
                                        className="focus:outline-none transition ease-in-out duration-100 inline-flex cursor-pointer hover:bg-gray-100 p-1 rounded-full"
                                    >
                                        <svg
                                            className="h-6 w-6 text-gray-400"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M9 19l7-7-7-7"
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </div>

                            <div className="flex flex-wrap mb-3 -mx-1">
                                {DAYS.map((day, index) => (
                                    <div key={index} style={{ width: "14.26%" }} className="px-0.5">
                                        <div className="text-gray-800 font-medium text-center text-xs">{day}</div>
                                    </div>
                                ))}
                            </div>

                            <div className="flex flex-wrap -mx-1">
                                {blankDays.map((_, index) => (
                                    <div
                                        key={index}
                                        style={{ width: "14.28%" }}
                                        className="text-center border p-1 border-transparent text-sm"
                                    ></div>
                                ))}
                                {noOfDays.map((date, index) => (
                                    <div key={index} style={{ width: "14.28%" }} className={"mb-1 px-0.5 "+ (compareDates(date, month+1, year,sesdateDay, sesdateMonth, sesdateYear) && ("text-slate-300"))}>
                                        <div
                                            onClick={() => getDateValue(date)}
                                            className={"cursor-pointer text-center py-2 border text-sm leading-none rounded-full leading-loose transition ease-in-out duration-100 hover:bg-gray-200 " + ((sesInfo.sesData.attendance[(date>9?date:("0"+date))+"-"+(((month+1)>9)?(month+1):"0"+(month+1))+"-"+year]) ? ("border-solid border-red-200") : ("border-solid border-transparent"))}
                                        >
                                            {date}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
                <h3 className="text-lg font-medium text-blue-600 my-2 ml-1">Classes on {currentDay}</h3>
                <ul className="">
                    {subjectsForDay.length > 0 ? (
                        subjectsForDay.map((subjectId) => (
                            <div key={subjectId} className="bg-white rounded-xl shadow p-2 mt-2">
                                <span className="text-cyan-950 text-gray-700 text-sm  px-2 py-1 rounded-lg bg-slate-100 font-semibold">{sesInfo.sesData.subjects[subjectId]}</span>
                                <div className="flex items-center gap-1 mt-1">
                                    <div
                                        role="button"
                                        class={"flex mt-1 w-full items-center rounded-lg p-0 transition-all hover:bg-slate-100 focus:bg-slate-100 active:bg-slate-100 " + (((sesInfo.sesData.attendance[selectedDate] && sesInfo.sesData.attendance[selectedDate][subjectId] && sesInfo.sesData.attendance[selectedDate][subjectId] === 'Absent') || false) ? ("bg-slate-200") : (""))}
                                    >
                                        <label
                                            htmlFor={`option-a-${subjectId}`}
                                            class="peer flex w-full cursor-pointer items-center px-2 py-2"
                                        >
                                            <div class="inline-flex items-center">
                                                <label class="flex items-center cursor-pointer relative" htmlFor={`option-a-${subjectId}`}>
                                                    <input type="checkbox" onChange={() => handleCheckboxChange(subjectId, "Absent")}
                                                        checked={(sesInfo.sesData.attendance[selectedDate] && sesInfo.sesData.attendance[selectedDate][subjectId] && sesInfo.sesData.attendance[selectedDate][subjectId] === 'Absent') || false}
                                                        class={"peer h-6 w-6 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800 "+ ((loadingStates[subjectId] && loadingStates[subjectId].Absent) && ("bg-slate-800 border-slate-800"))}
                                                        id={`option-a-${subjectId}`} />
                                                    <span class={"absolute text-white peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 "+ ((loadingStates[subjectId] && loadingStates[subjectId].Absent)? ("opacity-100"):("opacity-0"))}>
                                                        {(loadingStates[subjectId] && loadingStates[subjectId].Absent) ? (
                                                            <div className="w-4 h-4 rounded-full animate-spin border-2 border-solid border-white border-t-transparent"></div>
                                                        ) : (
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                className="h-4 w-4"
                                                                viewBox="0 0 20 20"
                                                                fill="currentColor"
                                                                stroke="currentColor"
                                                                strokeWidth="1"
                                                            >
                                                                <path
                                                                    fillRule="evenodd"
                                                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                                    clipRule="evenodd"
                                                                ></path>
                                                            </svg>
                                                        )}
                                                    </span>
                                                </label>
                                                <label class="cursor-pointer ml-2 text-slate-600 text-sm" htmlFor={`option-a-${subjectId}`}>
                                                    Absent
                                                </label>
                                            </div>
                                        </label>
                                    </div>
                                    <div
                                        role="button"
                                        class={"flex mt-1 w-full items-center rounded-lg p-0 transition-all hover:bg-slate-100 focus:bg-slate-100 active:bg-slate-100 " + (((sesInfo.sesData.attendance[selectedDate] && sesInfo.sesData.attendance[selectedDate][subjectId] && sesInfo.sesData.attendance[selectedDate][subjectId] === 'Cancel') || false) ? ("bg-slate-200") : (""))}
                                    >
                                        <label
                                            htmlFor={`option-b-${subjectId}`}
                                            class="peer flex w-full cursor-pointer items-center px-3 py-2"
                                        >
                                            <div class="inline-flex items-center">
                                                <label class="flex items-center cursor-pointer relative" htmlFor={`option-b-${subjectId}`}>
                                                    <input type="checkbox" onChange={() => handleCheckboxChange(subjectId, "Cancel")}
                                                        checked={(sesInfo.sesData.attendance[selectedDate] && sesInfo.sesData.attendance[selectedDate][subjectId] && sesInfo.sesData.attendance[selectedDate][subjectId] === 'Cancel') || false}
                                                        class={"peer h-6 w-6 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800 "+ ((loadingStates[subjectId] && loadingStates[subjectId].Cancel) && ("bg-slate-800 border-slate-800"))}
                                                        id={`option-b-${subjectId}`} />
                                                    <span class={"absolute text-white peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 "+ ((loadingStates[subjectId] && loadingStates[subjectId].Cancel)? ("opacity-100"):("opacity-0"))}>
                                                        {(loadingStates[subjectId] && loadingStates[subjectId].Cancel) ? (
                                                            <div className="w-4 h-4 rounded-full animate-spin border-2 border-solid border-white border-t-transparent"></div>
                                                        ) : (
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                className="h-4 w-4"
                                                                viewBox="0 0 20 20"
                                                                fill="currentColor"
                                                                stroke="currentColor"
                                                                strokeWidth="1"
                                                            >
                                                                <path
                                                                    fillRule="evenodd"
                                                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                                    clipRule="evenodd"
                                                                ></path>
                                                            </svg>
                                                        )}
                                                    </span>
                                                </label>
                                                <label class="cursor-pointer ml-2 text-slate-600 text-sm" htmlFor={`option-b-${subjectId}`}>
                                                    Cancel
                                                </label>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-gray-500 m-2">No classes scheduled for this day.</p>
                    )}
                </ul>

            </div>
            
        </div>
    )
}

